import { useRBAC } from '@strapi/helper-plugin';
import { pluginPermissions } from '../pluginPermissions';
const usePluginPermissions = () => {
  const {
    allowedActions,
    isLoading
  } = useRBAC(pluginPermissions);
  const {
    canDisplayPlugin,
    canEditMetadata_courseView,
    canCreateTestBank_courseView,
    canEditMetadata_containerView,
    canRollbackVersion_containerView,
    canReadItems_assessmentLearnosityView,
    canEditItems_assessmentLearnosityView,
    canAssignItems_assessmentLearnosityView,
    canCreateItems_assessmentLearnosityView,
    canDeleteTag_assessmentLearnosityView,
    canAssignExistingTag_assessmentLearnosityView,
    canCreateNewTag_assessmentLearnosityView,
    canEditMetadata_assessmentView,
    canDelete_containerDraftView,
    canDelete_courseDraftView,
    canConfigureTotalTime_assessmentView
  } = allowedActions;
  return {
    canDisplayPlugin,
    canEditMetadata_courseView,
    canCreateTestBank_courseView,
    canEditMetadata_containerView,
    canRollbackVersion_containerView,
    canReadItems_learnosityView: canReadItems_assessmentLearnosityView,
    canEditItems_learnosityView: canEditItems_assessmentLearnosityView,
    canAssignItems_learnosityView: canAssignItems_assessmentLearnosityView,
    canCreateItems_learnosityView: canCreateItems_assessmentLearnosityView,
    canDeleteTag_learnosityView: canDeleteTag_assessmentLearnosityView,
    canAssignExistingTag_learnosityView: canAssignExistingTag_assessmentLearnosityView,
    canCreateNewTag_learnosityView: canCreateNewTag_assessmentLearnosityView,
    isLoading,
    canEditMetadata_assessmentView,
    canDelete_containerDraftView,
    canDelete_courseDraftView,
    canConfigureTotalTime_assessmentView
  };
};
export default usePluginPermissions;